import React from 'react';
type SectionHeadingProps = {
  eyebrow: string;
  title: string;
  description?: string;
  align?: 'left' | 'center';
  tone?: 'light' | 'dark';
};
export function SectionHeading({
  eyebrow,
  title,
  description,
  align = 'center',
  tone = 'light'
}: SectionHeadingProps) {
  const isCenter = align === 'center';
  return <div className={isCenter ? 'mx-auto max-w-2xl text-center' : 'max-w-2xl'} data-id="element-108" data-mp="3k0yi4c45t9at">
      <p className="font-display text-[12px] font-bold uppercase tracking-[0.28em] text-gold" data-id="element-109" data-mp="bk3o7m5caz8v">
        {eyebrow}
      </p>
      <h2 className={`mt-3 font-display text-3xl font-extrabold uppercase tracking-tight sm:text-4xl ${tone === 'dark' ? 'text-white' : 'text-navy'}`} data-id="element-110" data-mp="gix2hgsgaua3">
        {title}
      </h2>
      <span className={`mt-5 block h-[3px] w-16 bg-gold ${isCenter ? 'mx-auto' : ''}`} aria-hidden="true" data-id="element-111" data-mp="6ru3qlmzurdz" />
      {description && <p className={`mt-5 text-[17px] leading-relaxed ${tone === 'dark' ? 'text-white/80' : 'text-gray-600'}`} data-id="element-112" data-mp="za7pvnyywox8">
          {description}
        </p>}
    </div>;
}